import React, { useEffect, useState } from 'react';

const AirPurifierAdmin = () => {
  const [platform, setPlatform] = useState(null);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

    if (isAndroid) {
      window.location.href = 'https://play.google.com/store/apps/details?id=com.SpatialGrid.airpurifier1&launch=true';
    } else if (isIOS) {
      setPlatform('ios');
    } else {
      setPlatform('unsupported');
    }
  }, []);

  const handleAppClipRedirect = () => {
    window.location.href = 'https://appclip.apple.com/id?p=com.SpatialGrid.Air-Purifier.Clip';
  };

  return (
    <div className="flex flex-col justify-center items-center h-screen gap-4">
      {platform === 'ios' && (
        <button
          onClick={handleAppClipRedirect}
          className="px-6 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
        >
          Click here to Open
        </button>
      )}
      {platform === 'unsupported' && (
        <p className="text-gray-500 text-lg">Unsupported platform</p>
      )}
      {/* {platform === 'ios' && (
        <p className="text-gray-500 text-sm">Click the button above to open the Air Purifier app</p>
      )} */}
    </div>
  );
};

export default AirPurifierAdmin;
